export const selectAuthStatus = (state) => state.auth.status;
export const selectAuthToken = (state) => state.auth.data;
